"use client";

import { Button } from "@/components/ui/button";
import { BookTextIcon } from "@/components/ui/book-text";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { supabase } from "@/lib/supabase";

const POLICY_BUCKET = "documentation";
const POLICY_FILE_PATH = "WoodsMeetingMinutesPolicy.pdf";
const POLICY_DOWNLOAD_FILENAME = "Woods Meeting Minutes Policy.pdf";

export function PolicyButton() {
  const handleDownload = () => {
    const downloadUrl = supabase.storage
      .from(POLICY_BUCKET)
      .getPublicUrl(POLICY_FILE_PATH, { download: POLICY_DOWNLOAD_FILENAME }).data.publicUrl;

    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = POLICY_DOWNLOAD_FILENAME;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          className="h-9 rounded-full px-3 text-sm"
          onClick={handleDownload}
          size="sm"
          type="button"
          variant="outline"
        >
          <BookTextIcon className="text-muted-foreground" size={14} />
          <span className="hidden sm:inline">Policy</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">
        <p>Download the meeting minutes policy</p>
      </TooltipContent>
    </Tooltip>
  );
}

